import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TextRound = styled.p`
@media (max-width: 440) {
    font-size: 1px;
    color: red;
}
`;

const Second = () => {
    const { t } = useTranslation();

    const styles = {
        img: {
            minHeight: "85vh",
            background: "rgba(10, 31, 68, 1)",
            backgroundImage: "url('./images/Main/SecondBackground.png')",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundBlendMode: "overlay",
        },
    };

    return (
        <section className="relative px-[20px] sm:px-[50px] md:px-12 lg:px-16 pt-[60px] pb-[50px] text-white"
                 style={styles.img}>
            <div className="mx-auto">
                <div className="mb-6">
                    <h2 className="text-[32px] sm:text-[36px] font-medium text-left mt-2">{t('course.0.description.title')}</h2>
                </div>

                <p className="text-[16px] sm:text-[22px] leading-relaxed text-left">
                    {t('course.0.description.content.0')}
                </p>
                <p className="text-[16px] sm:text-[22px] leading-relaxed text-left mt-4">
                    {t('course.0.description.content.7')} {t('course.0.description.content.1')}
                </p>

                <div className="mt-8">
                    <div className="flex justify-center sm:gap-12 gap-[40px] flex-wrap items-start">
                        <div className="flex flex-col items-center w-[25%]">
                            <div
                                className="w-[90px] h-[90px] sm:w-24 sm:h-24 md:w-[156px] md:h-[152px] bg-[#8C1C1C] shadow-lg flex items-center justify-center rounded-full text-[32.09px] sm:text-[36px] font-bold"
                            >
                                <h2 className='text-[32.09px] sm:text-[54px]'>16</h2>
                            </div>
                            <TextRound className="mt-3 text-[11.88px] sm:text-[20px] font-semibold text-center">
                                {t('course_overview.topics')}
                            </TextRound>
                        </div>

                        <div className="flex flex-col items-center w-[25%]">
                            <div
                                className="w-[90px] h-[90px] sm:w-24 sm:h-24 md:w-[156px] md:h-[152px] bg-[#8C1C1C] shadow-lg flex items-center justify-center rounded-full text-[32.09px] sm:text-[36px] font-bold"
                            >
                                <h2 className='text-[32.09px] sm:text-[54px]'>35</h2>
                            </div>
                            <TextRound className="mt-3 text-[11.88px] sm:text-[20px] font-semibold text-center">
                                {t('course_overview.lectures')}
                            </TextRound>
                        </div>

                        <div className="flex flex-col items-center w-[25%]">
                            <div
                                className="w-[90px] h-[90px] sm:w-24 sm:h-24 md:w-[156px] md:h-[152px] bg-[#8C1C1C] shadow-lg flex items-center justify-center rounded-full text-[32.09px] sm:text-[36px] font-bold"
                                style={{whiteSpace: "pre-line"}}
                            >
                                <h2 className='text-[21.39px] sm:text-[36px]'>56 {t('hours_min')} {"\n"} 18 {t('minute_min')}</h2>
                            </div>
                            <TextRound className="mt-3 text-[11.88px] sm:text-[20px] font-semibold text-center w-full">
                                {t('course_overview.ttl_duration')}
                            </TextRound>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Second;